/**
 * AI-Chat Design Tokens
 *
 * Farbwelt aus dem Claude-Design-Projekt "Kampagnen-Builder v2" —
 * bewusst lokal für den Chat-Bereich, ohne das globale MUI-Theme zu ändern.
 */

export const dc = {
  /** Seitenhintergrund (Arbeitsbereich) */
  bg: '#F4F7FE',
  /** Kartenhintergrund */
  surface: '#FFFFFF',
  /** Primärtext */
  ink: '#1B2559',
  /** Sekundärtext */
  muted: '#707EAE',
  /** Tertiärtext / Platzhalter */
  faint: '#A3AED0',
  /** Primärfarbe (Violett) */
  primary: '#4318FF',
  primaryHoverBg: '#F7F5FF',
  /** Verlauf für Assistent-Avatar */
  gradient: 'linear-gradient(135deg,#4318FF,#7551FF)',
  /** Erfolg */
  success: '#05CD99',
  /** Warnung (Gap-Banner) */
  warn: '#FFB547',
  warnBg: '#FFF8EC',
  warnBorder: '#F6E4C4',
  warnText: '#8A6320',
  /** Rahmen */
  border: '#E0E5F2',
  borderSoft: '#F0F3FA',
  /** User-Bubble */
  bubbleBg: '#F4F7FE',
  bubbleBorder: '#ECF0FA',
  /** Send-Button deaktiviert */
  sendDisabled: '#D5DCF0',
  /** Karten-Schatten */
  shadow: '0 4px 18px rgba(27,37,89,0.07)',
  shadowSelected: '0 6px 20px rgba(67,24,255,0.16)',
} as const;
